var _variants, _variants2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import '@emotion/react';
import { variant, getThemeValue } from '@tablekit/utils';
import { Resizable } from 're-resizable';
import { panelThemeNamespace, panelClassicTheme } from '../themes.js';
import { PanelPosition } from '../types.js';
import { StaticContainer } from './StaticPanel.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var ResizablePanelContainer = /*#__PURE__*/_styled(StaticContainer.withComponent(Resizable, process.env.NODE_ENV === "production" ? {
  target: "eyw0tav1"
} : {
  target: "eyw0tav1",
  label: "ResizablePanelContainer"
}), process.env.NODE_ENV === "production" ? {
  target: "eyw0tav0"
} : {
  target: "eyw0tav0",
  label: "ResizablePanelContainer"
})(">.resizer>div{transition:border-color 0.2s ease 0.1s;", variant({
  prop: 'position',
  variants: (_variants = {}, _defineProperty(_variants, PanelPosition.Left, process.env.NODE_ENV === "production" ? {
    name: "s7kbq6",
    styles: "border-right:2px solid transparent;right:0!important"
  } : {
    name: "15ntm0j-ResizablePanelContainer",
    styles: "border-right:2px solid transparent;right:0!important;label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _defineProperty(_variants, PanelPosition.Right, process.env.NODE_ENV === "production" ? {
    name: "k53tso",
    styles: "border-left:2px solid transparent;left:0!important"
  } : {
    name: "g7sgq0-ResizablePanelContainer",
    styles: "border-left:2px solid transparent;left:0!important;label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _defineProperty(_variants, PanelPosition.Bottom, process.env.NODE_ENV === "production" ? {
    name: "w05kch",
    styles: "border-top:2px solid transparent;top:0!important"
  } : {
    name: "121br3t-ResizablePanelContainer",
    styles: "border-top:2px solid transparent;top:0!important;label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _variants)
}), " ::after{transition:border-color 0.2s ease 0.1s;display:block;width:3px;height:20px;content:'';border-left:2px solid;border-right:2px solid;border-color:", getThemeValue("".concat(panelThemeNamespace, ".borderColor"), panelClassicTheme.borderColor), ";position:absolute;", variant({
  prop: 'position',
  variants: (_variants2 = {}, _defineProperty(_variants2, PanelPosition.Left, process.env.NODE_ENV === "production" ? {
    name: "1uf6gq4",
    styles: "top:50%;transform:translateY(-50%);right:5px"
  } : {
    name: "1orpcdt-ResizablePanelContainer",
    styles: "top:50%;transform:translateY(-50%);right:5px;label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _defineProperty(_variants2, PanelPosition.Right, process.env.NODE_ENV === "production" ? {
    name: "1wjirae",
    styles: "top:50%;transform:translateY(-50%);left:5px"
  } : {
    name: "7h668r-ResizablePanelContainer",
    styles: "top:50%;transform:translateY(-50%);left:5px;label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _defineProperty(_variants2, PanelPosition.Bottom, process.env.NODE_ENV === "production" ? {
    name: "16eassv",
    styles: "left:50%;transform:translateX(-50%) rotate(90deg)"
  } : {
    name: "ojuy7j-ResizablePanelContainer",
    styles: "left:50%;transform:translateX(-50%) rotate(90deg);label:ResizablePanelContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }), _variants2)
}), ";}::before{content:'';position:absolute;top:0;bottom:0;left:-10px;right:-10px;}:hover,:active{", function (_ref) {
  var position = _ref.position;
  return position === PanelPosition.Left ? 'border-right: 2px solid;' : 'border-left: 2px solid;';
}, " border-color:", getThemeValue("".concat(panelThemeNamespace, ".borderColorHover"), panelClassicTheme.borderColorHover), ";&::after{border-color:", getThemeValue("".concat(panelThemeNamespace, ".borderColorHover"), panelClassicTheme.borderColorHover), ";}}}");

export { ResizablePanelContainer };
